import Slideout from 'slideout';
import { trapFocus } from '../modules/slideoutFocusTrap';

import Component from '../Component';
import { Breakpoints } from '../constants';

export default class Drawer extends Component {
  MOBILE_DRAWER_SIZE = 300;
  DESKTOP_DRAWER_SIZE = 400;
  MOBILE_BREAKPOINT = Breakpoints.md;
  DESKTOP_BREAKPOINT = Breakpoints.md;

  constructor(theme, element) {
    super(theme, element);
    this.slideouts = {};
    this.isMobile = this.theme.breakpoint.order <= this.MOBILE_BREAKPOINT.order;
    this.isDesktop = (window.innerWidth >= Breakpoints.lg.min) ? true : false;
    this.lastFocus = document.activeElement;
    this.cartType = document.body.dataset.cartType;
    this.cartVisible = document.body.dataset.cartVisible == 'true';
    this.swipers = document.querySelectorAll('.swiper-container');
    this.theme = theme
    this.load();
  }

  load = () => {

    // Close sliders if they're open
    if (this.slideouts && this.slideouts.left) {
      this.slideouts.left.close();
    }

    if (this.slideouts && this.slideouts.right) {
      this.slideouts.right.close();
    }

    /* Move mobile menu out of section to document body because the slideout
         needs to put it to the sidebar, but it can't be in the body from the beginning
         because it needs section config */
    var bodyMenu = document.body.querySelector('#theme-menu');
    var mainBodyMenu = document.querySelector('#main-body #theme-menu');

    if (mainBodyMenu) {
      if (bodyMenu != null) bodyMenu.remove();

      document.body.append(mainBodyMenu);
    }

    var leftMenu = document.querySelector('#theme-menu');
    var rightMenu = document.querySelector('#cartSlideoutWrapper');

    /* Mobile Menu */
    this.createMenuDrawer(leftMenu, rightMenu);

    /* Cart */
    // Cart drawer is disabled in the settings
    if (!rightMenu) return;

    this.createCartDrawer(rightMenu, leftMenu);
  }

  createMenuDrawer = (left_menu, right_menu) => {
    var self = this;
    var slideoutID;
    var slideoutLeft = this.createDrawer('left', left_menu, right_menu);
    var isInitialOpen = true;

    var menuOpenBtns = document.querySelectorAll('.slide-menu-mobile');
    var menuCloseBtns = document.querySelectorAll('.mobile-menu-close');



    const handleMenuOpen = () => {
      slideoutID = self.slideouts.left.menu.id;

      slideoutLeft.toggle();
      trapFocus(slideoutID, isInitialOpen);

    }

    const handleMenuClose = () => {
      slideoutLeft.close();
    }

    menuOpenBtns.forEach(menuOpenBtn => {
      menuOpenBtn.removeEventListener('click', handleMenuOpen);
      menuOpenBtn.addEventListener('click', handleMenuOpen);
    });

    menuCloseBtns.forEach(menuCloseBtn => {
      menuCloseBtn.removeEventListener('click', handleMenuClose);
      menuCloseBtn.addEventListener('click', handleMenuClose);
    });

    // Disable mobile drawer on desktop
    if (this.theme.breakpoint.order <= this.MOBILE_BREAKPOINT.order) {
      slideoutLeft.disableTouch();
    }

    // Add events for sidebar manipulation from outside
    left_menu.addEventListener('mobile:toggle', slideoutLeft.toggle.bind(slideoutLeft), false);
  }

  createCartDrawer = (right_menu, left_menu) => {
    var self = this;
    var slideoutID;
    var slideoutRight = this.createDrawer('right', right_menu, left_menu);
    var isInitialOpen = true;
    var cartOpenBtn = document.querySelectorAll('.slide-menu-cart');
    var cartCloseBtn = document.querySelectorAll('.cart-menu-close');

    const handleCartOpen = (e) => {
      slideoutID = self.slideouts.right.menu.id;

      slideoutRight.toggle();
      trapFocus(slideoutID, isInitialOpen);
      // prevent non-ajax basket
      e.preventDefault();
      return false;
    }

    // Toggle buttons (for desktop, mobile, sticky headers)
    cartOpenBtn.forEach(item => {
      item.removeEventListener('click', handleCartOpen);

      item.addEventListener('click', function (e) {
        handleCartOpen(e);
      });
    })

    cartCloseBtn.forEach(btn => {
      btn.addEventListener('click', function () {
        // @todo add a class when the persistent cart is active maybe.
        slideoutRight.close();
      });
    })

    // Add events for sidebar manipulation from outside
    right_menu.addEventListener('cart:toggle', slideoutRight.toggle.bind(slideoutRight), false);
    right_menu.addEventListener('cart:open', slideoutRight.open.bind(slideoutRight), false);
  }

  onWindowResizeBreakpoint = ({ breakpoint, oldBreakpoint }) => {
    const wasMobile = this.isMobile;
    this.isMobile = breakpoint.order <= this.MOBILE_BREAKPOINT.order;
    this.isDesktop = (window.innerWidth > Breakpoints.md.max) ? true : false;

    if (this.isDesktop) {
      // Close mobile menu.
      this.slideouts.left.close();

      // Open persistent cart.
      if (this.cartType === 'persistent' && this.cartVisible === true) {

        // check for the slide-open class?
        const slideOutClass = 'slideout-open'
        const isSlideoutOpen = document.querySelector('html').classList.contains(slideOutClass)

        // check if the drawer is actually visible before the recalculation
        if (isSlideoutOpen) {
          this.slideouts.right.open();
        }
      }
    }

    if (this.isMobile === wasMobile) {
      // mobile <=> desktop was not changed
      return;
    }

    if (this.isMobile) {
      this.slideouts.left.disableTouch();

      // Open persistent cart.
      if (this.cartType === 'persistent' && this.cartVisible === true) {
        this.slideouts.right.close();
      }
    } else {
      this.slideouts.left.enableTouch();
    }

    if (!this.slideouts.right) {
      // cart slider is disabled
      return;
    }

    // Resize right drawer based on window width
    const slideout = this.slideouts.right;
    const padding = (this.isMobile) ? this.MOBILE_DRAWER_SIZE : this.DESKTOP_DRAWER_SIZE;
    slideout._translateTo = slideout._padding = padding * slideout._orientation;

    if (slideout._opened) {
      const transform = "translateX(" + (padding * slideout._orientation) + "px)";
      slideout.panel.style.webkitTransform = transform;
      slideout.panel.style.transform = transform;
    }
  }

  /**
   * Create side drawer
   *
   * @param {'left' | 'right'} side
   */
  createDrawer = (side, menu, hidden_menu) => {
    const overlay = document.querySelector('#slideout-overlay');
    let panel = /** @type {HTMLDivElement} */ (document.querySelector('#main-body'));
    let padding = this.MOBILE_DRAWER_SIZE;
    let self = this;
    let easing = 'ease';

    if (side === 'right' && !this.isMobile) {
      padding = this.DESKTOP_DRAWER_SIZE;
    }

    if (this.cartType === 'persistent') {
      easing = '0s cubic-bezier(0,0,1,1)';
    }

    const slideout = new Slideout({
      'panel': panel,
      'menu': menu,
      'padding': padding,
      'tolerance': 70,
      'side': side,
      'touch': false,
      // 'easing': easing
    });

    const dir = (side === 'right') ? -1 : 1;
    this.slideouts[side] = slideout;
    menu.classList.add('slideout-panel-hidden');

    if (this.cartType !== 'persistent') {
      overlay.addEventListener('click', slideout.close.bind(slideout));

      // Handle slide to close
      let touch_start = null;
      overlay.addEventListener('touchstart', function (/** @type {TouchEvent} */ event) {
        if (!slideout.isOpen()) return;

        event.preventDefault();
        touch_start = event.touches[0].pageX;
      }, { passive: true });

      overlay.addEventListener('touchmove', function (/** @type {TouchEvent} */ event) {
        if (!slideout.isOpen()) return;

        const offset = touch_start - event.touches[0].pageX;
        let translate = (dir * padding) - offset;

        if (Math.abs(translate) > padding) {
          translate = (dir * padding);
        }
        panel.style.transform = 'translateX(' + translate + 'px)';
      }, { passive: true });

      overlay.addEventListener('touchend', function (/** @type {TouchEvent} */ event) {
        if (!slideout.isOpen()) return;

        const offset = touch_start - event.changedTouches[0].pageX;

        if (offset === 0 || Math.abs(offset) > 70) {
          slideout.close();
        } else {
          panel.style.transform = 'translateX(' + (dir * padding) + 'px)';
        }
      });
    }

    slideout.on('beforeopen', function () {
      menu.classList.remove('slideout-panel-hidden');

      if (hidden_menu) {
        hidden_menu.classList.add('slideout-panel-hidden');
      }

      if ((self.cartType !== 'persistent' && !self.isMobile) || this._side !== 'right' || self.isMobile) {

        overlay.classList.add('show');
        const cartClose = /** @type {HTMLButtonElement} */ (document.querySelector('.cart-menu-close'));
        const menuClose = /** @type {HTMLButtonElement} */ (document.querySelector('.menu-close-icon'));
        const filterClose = /** @type {HTMLButtonElement} */ (document.querySelector('.filter-close-icon'));
        const marginTop = window.scrollY + 'px';
        const stickyHeader = /** @type {HTMLDivElement} */ (document.querySelector('.sticky-header-wrapper.sticky'));

        if (cartClose) cartClose.focus();
        if (menuClose) menuClose.focus();
        if (filterClose) filterClose.focus();

        panel.style.position = 'fixed';
        panel.style.marginTop = '-' + marginTop;

        // Apply opposite effect to the sticky header
        if (stickyHeader) {
          stickyHeader.style.marginTop = marginTop;
          stickyHeader.style.transform = 'translateX(0)';
        }
      }
    });

    slideout.on('open', function () {
      if (self.cartType === 'persistent') {
        // Enable fixed cart if re opened

        document.body.setAttribute('data-persistent-cart-state', 'open');
        self.theme.sessionHandler.changeCartSessionState('open');

        // Trigger resize of slideshow.
        const event = new Event('update-swipers');
        window.dispatchEvent(event);
      }
    });

    slideout.on('beforeclose', function () {
      const scrollTop = parseInt(panel.style.marginTop) * -1;
      const drawerStatus = /** @type {HTMLHeadingElement} */ (document.querySelector('.js-cart-drawer-status'));

      overlay.classList.remove('show');
      if (drawerStatus) {
        drawerStatus.innerText = '';
      }

      panel.style.position = '';
      panel.style.marginTop = '';

      if (self.cartType === 'persistent' && !self.isMobile) {
        // @todo nothing at present however place for
        // on before close events in from the persisitent cart
      } else {
        // I hate this, but basically the smallest footprint without potential for knockon
        // Resets the html scroll behavior,
        document.documentElement.style.scrollBehavior = 'auto';
        window.scrollTo(0, scrollTop);
        document.documentElement.style.scrollBehavior = '';
      }
    });

    slideout.on('close', function () {
      const stickyHeader = /** @type {HTMLDivElement} */ (document.querySelector('.sticky-header-wrapper'));

      if (stickyHeader) {
        stickyHeader.style.marginTop = '0';
        stickyHeader.style.transform = '';
      }

      menu.classList.add('slideout-panel-hidden');

      if (self.cartType === 'persistent') {
        // disable fixed cart if re opened
        document.body.setAttribute('data-persistent-cart-state', 'closed')
        self.theme.sessionHandler.changeCartSessionState("closed")
        // Trigger resize to update any slideshows as they will have an incorrect width.
        window.dispatchEvent(new Event('resize'));
      }
    });

    slideout.on('translate', function (translated) {
      var hidden = false;

      if (translated === 0) {
        hidden = true;
      } else if (side === 'left') {
        hidden = translated <= 0;
      } else if (side === 'right') {
        hidden = translated >= 0;
      }

      menu.classList.toggle('slideout-panel-hidden', hidden);

      if (hidden_menu) {
        hidden_menu.classList.toggle('slideout-panel-hidden', !hidden);
      }
    });

    if (
      this.cartType === 'persistent' &&
      this.cartVisible == true &&
      side === 'right' &&
      this.isDesktop &&
      self.theme.sessionHandler.fixedCartShouldOpenOnLoad() // true when the cart hasnt been hidden
    ) {
      slideout.open();
    }

    return slideout;
  }
}
